module.exports = __webpack_public_path__ + "static/media/Salandit_gaussian2.a45324bb.png";